import { LANDING_ACTIONS } from 'const/landingPage';

export const LANDING_PAGE_TRANSLATIONS = {
  ADVANTAGES: {
    TITLES: {
      SIMPLE: 'de simplicité',
      SECURE: 'de sécurité',
      FAST: 'de rapidité',
      CASH: 'de trésorerie',
    },
    DESCRIPTIONS: {
      SALES_SIMPLE:
        'Outil facile d’utilisation Tout en 1. Gain de temps sur la partie administrative',
      SALES_CASH:
        'Favoriser la transformation des devis, facturer + vite, relancer les clients à temps',
      SALES_SECURE:
        'Conformité fiscale. Données clients centralisées et structurées',
      EXPENSES_FAST: `Validation « bon à payer » et Paiement des factures en 1 clic\n
        Paiement immédiat ou à échéance\n
        'Choix du compte en banque payeur`,
      EXPENSES_SIMPLE:
        'Traçabilité des bons à payer. Réconciliation automatique entre factures et paiements. Visualisation de vos dépenses en temps réel.',
      EXPENSES_SECURE:
        'IBAN vérifiés pour réduire la fraude. Transactions sécurisées sans vous connecter à votre compte bancaire',
    },
    MY_EXCO_TITLES: {
      INVOICE_SEARCH: 'Moteur de recherche de factures',
      HR_INDICATORS: 'Indicateurs de gestion et RH en temps réel',
      TREASURY: 'Suivi de trésorerie',
    },
    SAFE_TITLES: {
      STORAGE: 'Stockage',
      MOBILITY: 'Mobilité',
      SECURITY: 'Sécurité',
    },
    MY_EXCO_POINTS: {
      INVOICE_ANALYZE: "Analysez vos factures d'achats et de ventes",
      INVOICE_COMPARE: 'Comparez et pointez les prix d’achat',
      INVOICE_TRACK: 'Suivez les volumes d’achat',
      HR_TURNOVER: 'Chiffre d’affaires réalisé et potentiel',
      HR_SALARY: 'Coût salarial et heures travaillées',
      HR_HOURLY: 'Chiffre généré pour 1h travaillée',
      HR_PERCENT: '% Charges de personnel /chiffre d’affaires',
      TREASURY_CASH: 'Trésorerie disponible',
      TREASURY_OWED: 'Ce que vous devez à vos fournisseurs et prestataires',
      TREASURY_CREDITED: 'Ce que les clients vous doivent',
    },
    WAIBI_POINTS_TITLE:
      'Grâce à notre offre "Mon tableau de bord", vous pouvez :',
    WAIBI_POINTS: {
      ONLINE_CONSULTATION: `Consulter votre tableau de bord en ligne afin de suivre l’avancement de vos objectifs`,
      COMMENTS: `Accéder à vos commentaires, comparer le réalisé au budget, à N-1`,
      RESULTS: `Avoir une approche du résultat de fin d’année de manière anticipée`,
      PERSONALIZED_SUPPORT: `Bénéficier d'un accompagnement personnalisé`,
      REACTIVE_MANAGEMENT: `Piloter votre entreprise de manière plus sereine et réactive`,
    },
    SAFE_POINTS: {
      STORAGE: `Vous déposez directement les bulletins de salaire de vos salariés dans eDoc et la plateforme gère de manière autonome leur distribution dans chaque coffre-fort numérique de vos salariés.`,
      MOBILITY: `Le salarié accède à ses bulletins de salaire où qu'il soit grâce à l'application mobile eDocPerso, disponible sur l'App Store et Google Play.`,
      SECURITY: `Le coffre répond aux exigences en matière de sécurité, de confidentialité et de conservation à valeur probatoire.`,
    },
  },
  SALES: {
    SUBTITLE: 'Pilotez votre chiffre d’affaires !',
    DESCRIPTION:
      'Après avoir élaboré vos devis, facturez-les en 1 clic. Pilotez votre chiffre d’affaires et gérez votre trésorerie par le suivi des encaissements clients et la relance de vos impayés.',
    DISCLAIMER: 'Ce service est accessible pour les abonnés au Bouquet My Exco',
  },
  WAIBI: {
    DESCRIPTION: `Vous souhaitez aller plus loin dans la gestion de votre entreprise ?`,
    DISCLAIMER: null,
    CONSULTANT_CONTACT_SUCCESS:
      'Votre demande a bien été prise en compte, nous vous recontacterons dans les meilleurs délais',
  },
  EXPENSES: {
    SUBTITLE: 'Payez simplement vos factures fournisseurs !',
    DESCRIPTION:
      'Vous perdez des heures à saisir vos virements à la main ? Découvrez le paiement sécurisé de vos factures en un clic.',
    DISCLAIMER: 'Ce service est accessible pour les abonnés au Bouquet My Exco',
  },
  MY_EXCO: {
    SUBTITLE: 'Ne naviguez plus à vue, pilotez !',
    DESCRIPTION:
      'La plateforme digitale qui centralise les données et solutions de gestion pour rendre simple et efficace le pilotage de votre entreprise au quotidien.',
  },
  HELP: {
    SUBTITLE: 'Besoin d’un coup de pouce ?',
    DESCRIPTION:
      'Retrouvez ci-dessous nos foires aux questions, nos vidéos tuto. Et au besoin prenez rendez-vous avec un de nos coach digital !\n',
  },
  SAFE: {
    DESCRIPTION:
      'eDocPerso est un espace de stockage personnel et sécurisé dans lequel vos salariés reçoivent automatiquement leurs bulletins de salaire au format numérique. \n Ce coffre-fort leur appartient : en tant qu’employeur, vous y déposez les bulletins de salaire mais vous n’avez aucun droit d’accès sur le contenu.',
  },
  SUBSCRIBE: 'Souscrire',
  MAKE_APPOINTMENT: 'Prendre RDV',
  TAX: 'HT / Mois',
  SAFE_TAX: 'HT / bulletin de salaire',
  SALES_COST_BLOCK_TEXT: 'Gardez le contrôle de vos ventes !',
  EXPENSES_COST_BLOCK_TEXT: 'Payez simplement vos factures fournisseurs !',
  MY_EXCO_COST_BLOCK_TEXT: 'Ne naviguez plus à vue, pilotez ',
  WAIBI_COST_BLOCK_TEXT: 'Plus d’informations',
  SAFE_COST_BLOCK_TEXT:
    'Offrez à vos salariés un service sécurisé et accessible à vie',
  WAIBI_COST: 'Prix à définir\nselon vos besoins',
  BUTTONS_TEXT: {
    [LANDING_ACTIONS.ADD_TO_CART]: 'Ajouter au panier',
    [LANDING_ACTIONS.VISIT_CART_PAGE]: 'Voir mon panier',
    [LANDING_ACTIONS.CONTACT_CONSULTANT]: 'Etre contacté par mon conseiller',
  },
  AVAILABLE_DAY_AND_NIGHT:
    'Tout le pilotage et l’information au même endroit ! Disponible',
  DAY_AND_NIGHT_NUMBERS: '24/7 !',
  BACK_TO_STORE: 'Store',
  SUBSCRIBE_SUCCESS_TEXT: 'Merci ! Le module est ajouté à votre panier ',
  TOOLTIP_RETURN_TO_STORE: 'Retourner au Store',

  CARBON_FOOTPRINT: {
    TITLE: 'Bilan carbone',
    PARAGRAPH_1:
      'Votre empreinte carbone flash est élaborée à partir du compte de charges du fichier des écritures comptable de votre entreprise. Ces données sont multipliées par des facteurs d’émissions en ratio monétaires provenant de la base empreinte de l’ADEME.',
    PARAGRAPH_2_START: 'Caractère exploratoire : ',
    PARAGRAPH_2:
      'cette empreinte flash vise à offrir une première vision des émissions de gaz à effet de serre de votre entreprise et non à établir une évaluation exhaustive. Elle ne constitue ni une certification ni une validation de vos émissions et n’engage pas la responsabilité d’Exco FSO.',
    PARAGRAPH_3:
      'Ces informations sont destinées uniquement à un usage interne et ne doivent pas servir à une communication externe.',
    CHART_TITLE: 'Répartition des émissions par catégories en tonnes CO2e',
    UNCERTAINTY: 'Incertitude :',
  },
};
